import React from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toggleCategoryDropdown } from "../../../redux/slices/activityCategories";

export default function NavItem({ text, linkTo }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { categoryDropdownActive } = useSelector((state) => state.activityCategories);

  const handleClick = () => {
    if (text === "Home") return navigate("/");
    if (text === "Create") {
      dispatch(toggleCategoryDropdown({active: categoryDropdownActive ? false : true}));
    }
    if (text == "All Duonuts") return navigate("/allduonuts");
    if (text == "My Duonuts") return navigate("/myduonuts");
  };

  return (
    <li className="navbar-item" onClick={handleClick}>
      {text}
      {text === "Create" && <img src="/assets/icons/create-down.svg" className="select-icon" />}
    </li>
  );
}
